/* Lyzza — pages produit (matelas, canapés, poufs) : révélations, composition, comparatif, bloc d'achat */
(function () {
  if (window.__lzmInit) return;
  window.__lzmInit = true;
  var d = document;
  d.documentElement.classList.add('lzm-js');

  /* ---------- utilitaires ---------- */
  function $$(sel, root) { return Array.prototype.slice.call((root || d).querySelectorAll(sel)); }
  function readJSON(el) { try { return JSON.parse(el.textContent || el.getAttribute('data-json') || '{}'); } catch (e) { return null; } }
  function fmtMoney(cents, fmt) {
    fmt = fmt || '€{{amount}}';
    var n = Math.round(Math.abs(cents)) / 100;
    function f(num, dec, th, dc) { var p = num.toFixed(dec).split('.'); p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, th); return p.join(dc); }
    var m = fmt.match(/\{\{\s*(\w+)\s*\}\}/), key = m ? m[1] : 'amount', v;
    if (key === 'amount_no_decimals') v = f(n, 0, ',', '.');
    else if (key === 'amount_with_comma_separator') v = f(n, 2, '.', ',');
    else if (key === 'amount_no_decimals_with_comma_separator') v = f(n, 0, '.', ',');
    else if (key === 'amount_with_apostrophe_separator') v = f(n, 2, "'", '.');
    else v = f(n, 2, ',', '.');
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, v);
  }

  /* ---------- taille sélectionnée dans le bloc d'achat ---------- */
  var sizeListeners = [];
  function currentSize() {
    var info = d.querySelector('.wt-product__info') || d;
    var r = info.querySelector('input[type="radio"]:checked');
    if (r && r.value) return r.value;
    var s = info.querySelector('select[name*="option"], select[name="id"]');
    if (s && s.options[s.selectedIndex]) return (s.options[s.selectedIndex].text || '').split('/')[0].trim();
    return null;
  }
  function emitSize() { var s = currentSize(); if (!s) return; sizeListeners.forEach(function (fn) { try { fn(s); } catch (e) {} }); }
  function onSize(fn) { sizeListeners.push(fn); var s = currentSize(); if (s) fn(s); }
  d.addEventListener('variant:change', function () { setTimeout(emitSize, 0); });
  d.addEventListener('change', function (e) { if (e.target && e.target.closest && e.target.closest('.wt-product__info')) setTimeout(emitSize, 0); });
  function pickSize(size) {
    var info = d.querySelector('.wt-product__info') || d;
    var r = $$('input[type="radio"]', info).filter(function (i) { return i.value === size; })[0];
    if (r && !r.checked) {
      var lab = r.id ? info.querySelector('label[for="' + r.id + '"]') : null;
      if (lab) lab.click(); else r.click();
    }
    setTimeout(emitSize, 50);
    var box = d.querySelector('.wt-product__info');
    if (box) box.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  /* ---------- apparitions au défilement ---------- */
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }) : null;
  function reveal(root) {
    $$('.lzm-rv:not(.is-in)', root).forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (!io || r.top < window.innerHeight * 0.92) { el.classList.add('is-in'); } else { io.observe(el); }
    });
  }

  /* ---------- sélecteur de modèle (bloc d'achat) ---------- */
  function initSwitch(root) {
    $$('[data-lzm-sw-map]', root).forEach(function (a) {
      if (a.__lzm) return; a.__lzm = true;
      var map = readJSON({ textContent: a.getAttribute('data-lzm-sw-map') }) || {};
      var base = a.getAttribute('href');
      onSize(function (s) { a.setAttribute('href', map[s] || base); });
    });
  }

  /* ---------- composition interactive ---------- */
  function initLayers(root) {
    $$('[data-lzm-ly]', root).forEach(function (sec) {
      if (sec.__lzm) return; sec.__lzm = true;
      var items = $$('[data-lzm-li]', sec), spots = $$('[data-lzm-hs]', sec);
      function on(i) {
        items.forEach(function (el) { var a = el.getAttribute('data-lzm-li') === i; el.classList.toggle('is-on', a); var b = el.querySelector('button'); if (b) b.setAttribute('aria-pressed', a ? 'true' : 'false'); });
        spots.forEach(function (el) { el.classList.toggle('is-on', el.getAttribute('data-lzm-hs') === i); });
      }
      items.forEach(function (el) {
        var i = el.getAttribute('data-lzm-li'), b = el.querySelector('button');
        el.addEventListener('mouseenter', function () { on(i); });
        if (b) { b.addEventListener('click', function () { on(i); }); b.addEventListener('focus', function () { on(i); }); }
      });
      spots.forEach(function (el) {
        el.addEventListener('click', function () {
          var i = el.getAttribute('data-lzm-hs'); on(i);
          var t = sec.querySelector('[data-lzm-li="' + i + '"]');
          if (t && window.innerWidth < 990) t.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
      });
      if (items.length) on(items[0].getAttribute('data-lzm-li'));
    });
  }

  /* ---------- comparatif ---------- */
  function initCompare(root) {
    $$('[data-lzm-cmp]', root).forEach(function (sec) {
      if (sec.__lzm) return; sec.__lzm = true;
      var src = sec.querySelector('[data-lzm-cmp-data]'), data = src ? readJSON(src) : null;
      if (!data) return;
      var btns = $$('[data-lzm-size]', sec);
      var keys = (data.keys && data.keys.length) ? data.keys : ['a', 'b'];
      function set(size) {
        for (var i = 0; i < keys.length; i++) { if (!data[keys[i]] || !data[keys[i]].v[size]) return; }
        var idx = data.sizes.indexOf(size);
        btns.forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-lzm-size') === size ? 'true' : 'false'); });
        keys.forEach(function (k) {
          var v = data[k].v[size];
          $$('[data-lzm-price="' + k + '"]', sec).forEach(function (el) { el.textContent = v.p; });
          $$('[data-lzm-link="' + k + '"]', sec).forEach(function (el) { el.setAttribute('href', v.u); });
          $$('[data-lzm-pick="' + k + '"]', sec).forEach(function (el) { el.setAttribute('data-size', size); });
        });
        $$('[data-lzm-w]', sec).forEach(function (el) {
          var vals = (el.getAttribute('data-lzm-w') || '').split('|');
          if (vals[idx]) el.textContent = vals[idx].trim();
        });
        $$('[data-lzm-diff]', sec).forEach(function (el) {
          var me = el.getAttribute('data-lzm-diff'), other = (data.cur && data.cur !== me && data[data.cur]) ? data.cur : (me === 'a' ? 'b' : 'a');
          var diff = data[me].v[size].c - data[other].v[size].c;
          el.textContent = diff === 0 ? '' : (diff > 0 ? '+' : '−') + fmtMoney(diff, data.fmt) + ' vs ' + data[other].n;
        });
        $$('[data-lzm-size-label]', sec).forEach(function (el) { el.textContent = size.replace('x', ' × '); });
      }
      btns.forEach(function (b) { b.addEventListener('click', function () { set(b.getAttribute('data-lzm-size')); }); });
      $$('[data-lzm-pick]', sec).forEach(function (el) {
        el.addEventListener('click', function (e) { e.preventDefault(); pickSize(el.getAttribute('data-size')); });
      });
      set(data.def && data.a.v[data.def] ? data.def : data.sizes[Math.min(1, data.sizes.length - 1)]);
      if (data.cur) onSize(set);
    });
  }

  /* ---------- appel final ---------- */
  function initFinal(root) {
    $$('[data-lzm-fin]', root).forEach(function (sec) {
      if (sec.__lzm) return; sec.__lzm = true;
      var src = sec.querySelector('[data-lzm-fin-data]'), data = src ? readJSON(src) : null;
      var price = sec.querySelector('[data-lzm-fin-price]'), lab = sec.querySelector('[data-lzm-fin-size]');
      var cmpEl = sec.querySelector('[data-lzm-fin-cmp]'), pctEl = sec.querySelector('[data-lzm-fin-pct]');
      if (data && data.v) onSize(function (s) {
        if (!data.v[s]) return;
        if (price) price.textContent = data.v[s];
        if (lab) lab.textContent = s.replace('x', ' × ');
        if (data.cmp) {
          var c = data.cmp[s];
          if (cmpEl) { cmpEl.hidden = !c; cmpEl.textContent = c ? c[0] : ''; }
          if (pctEl) { pctEl.hidden = !c; pctEl.textContent = c ? '-' + c[1] + '%' : ''; }
        }
      });
      $$('[data-lzm-atc]', sec).forEach(function (btn) {
        btn.addEventListener('click', function () {
          var b = d.querySelector('.wt-product__info .product-form__submit') || d.querySelector('form[action*="/cart/add"] [type="submit"]');
          if (!b) return;
          b.scrollIntoView({ behavior: 'smooth', block: 'center' });
          b.click();
        });
      });
    });
  }

  function init(root) { reveal(root); initSwitch(root); initLayers(root); initCompare(root); initFinal(root); }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', function () { init(d); }); else init(d);
  d.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();